import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'app-control-layout',
  styleUrls: ['./control-layout.component.scss'],
  templateUrl: './control-layout.component.html'
})
export class ControlLayoutComponent extends ControlBaseDirective implements OnInit, AfterContentInit {
  @Output() changedEvent = new EventEmitter<any>();
  @Input() additionalText?: string;
  
  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) {
    super(roleService, applicationContext);
    this.label = '';
  }

  public ngAfterContentInit(): void {
    if (this.control) {
      this.control.valueChanges.subscribe(x => this.changedEvent.emit(x));
    }
  }

  public isRequiredField = (): boolean => {
    const { validator } = this.control
    if (validator) {
        const validation = validator(new FormControl())
        return validation !== null && validation.required === true
    }
    return false
  };


  //label names often include a ':' which isn't always wanted
  //get the label text without the ':'
  public get labelName(): string {
    if(this.label[this.label.length - 1] == ':'){
      return this.label.slice(0, this.label.length - 1);
    }

    return this.label;
  }

  public ngOnInit(): void {
  }
}
